import React from 'react';
import { ExternalLink, X } from 'lucide-react';

const TimelineEvidencePreview = ({ preview, onClose }) => {
    if (!preview) return null;
    const meta = Array.isArray(preview.meta) ? preview.meta : [];

    return (
        <>
            <div className="library-rag-preview-header">
                <div className="library-rag-preview-heading">
                    <div className="library-rag-preview-title" title={preview.title}>
                        {preview.title}
                    </div>
                    <div className="library-rag-preview-meta">
                        {preview.sourceTypeLabel}{preview.citationNumber ? ` · Source ${preview.citationNumber}` : ''}
                    </div>
                </div>
                <div className="library-rag-preview-actions" aria-label="Source preview actions">
                    {preview.url ? (
                        <a
                            className="library-rag-preview-control"
                            href={preview.url}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={preview.isOutlookEmail ? 'Open email in Outlook' : 'Open related CaseDB record'}
                            title={preview.isOutlookEmail ? 'Open email in Outlook' : 'Open related CaseDB record'}
                        >
                            <ExternalLink size={16} />
                        </a>
                    ) : null}
                    <button
                        type="button"
                        className="library-rag-preview-control"
                        onClick={onClose}
                        aria-label="Close timeline source preview"
                        title="Close preview"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
            <div className="library-rag-timeline-evidence-preview">
                <div className="library-rag-timeline-evidence-type">{preview.sourceTypeLabel}</div>
                {meta.length > 0 ? (
                    <div className="library-rag-timeline-evidence-meta">
                        {meta.map((item, index) => (
                            <span key={`timeline-evidence-meta-${index}`}>{item}</span>
                        ))}
                    </div>
                ) : null}
                {preview.excerpt ? (
                    <div className="library-rag-timeline-evidence-excerpt">{preview.excerpt}</div>
                ) : (
                    <div className="library-rag-timeline-evidence-empty">No excerpt was provided for this source. The source identifier is preserved above.</div>
                )}
            </div>
        </>
    );
};

export default TimelineEvidencePreview;
